// extracted by mini-css-extract-plugin
export var divider = "_p2-0";
export var systemMessage = "_p2-1";
export var systemMessageWrapper = "_p2-2";